import { get, post, upload } from "./api";
import routes from "./end-points";

const MinFileSize = 0;
const MaxFileSize = 5 * 1024 * 1024;

export const profileApi = {
    init: () => get(routes.profile.init),

    save: (dto) => post(routes.profile.save, dto),

    changePassword: (dto) => post(routes.profile.changePassword, dto),

    getProfileImageUrl: (userId) => routes.profile.profileImageUrl(userId),

    uploadProfilePhoto: (file) => {
        if (file.size < MinFileSize) {
            setTimeout(() => (file.value = ""), 0);
            return Promise.reject("file-is-empty");
        }
        if (file.size > MaxFileSize) {
            setTimeout(() => (file.value = ""), 0);
            return Promise.reject("file-is-too-big");
        }
        const form_data = new FormData();
        form_data.append("file", file);

        setTimeout(() => (file.value = ""), 0);
        return upload(routes.profile.uploadProfilePhoto, form_data);
    },
};
